import { render, staticRenderFns } from "./HotspotsView.vue?vue&type=template&id=3dbbcba5"
import script from "./HotspotsView.vue?vue&type=script&lang=js"
export * from "./HotspotsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports